import { render } from "./partnerDetail.vue?vue&type=template&id=65c5bae2&scoped=true"
import script from "./partnerDetail.vue?vue&type=script&lang=js"
export * from "./partnerDetail.vue?vue&type=script&lang=js"

import "./partnerDetail.vue?vue&type=style&index=0&id=65c5bae2&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c5bae2"]])

export default __exports__